<lms-breadcrumb [label]="'agents.create'"></lms-breadcrumb>
<ac-administrators-editor
  *ngIf="tooltips"
  action="create"
  [tooltips]="tooltips"
  (save)="onSave($event)"
  (cancel)="cancel()"
></ac-administrators-editor>
